import {
	SECTORS_SET_ALL,
	SECTORS_SET_LIST,
	SECTORS_SET_MANAGER_USERS_LIST, SECTORS_SET_PDCS,
	SECTORS_UPDATE_LIST
} from "./../types";

import { createReducer } from "./functions";

const initialState = {
	sectorsList: {},
	page: 0,
	pages: 0,
	pageSize: 10,
	hasNext: true,
	currentFilters: {},
	managerUsersList: [],
	pdcs: [],
};

const setSectorsList = {
	[SECTORS_SET_LIST]: (state, action) => {
		const page = action.payload.hasOwnProperty("page")
			? action.payload.page
			: state.page;
		const pages = action.payload.hasOwnProperty("pages")
			? action.payload.pages
			: state.pages;
		let hasNext = true;

		if (page === 0 || page === pages) {
			hasNext = false;
		}

		return {
			...state,
			sectorsList: action.payload.docs,
			page,
			pages,
			hasNext,
		};
	},
	[SECTORS_SET_PDCS]: (state, action) => {
		return {
			...state,
			pdcs: action.pdcs,
		};
	},
	[SECTORS_SET_ALL]: (state, action) => {
		return {
			...state,
			sectorsList: [...action.sectorsList],
		};
	},
};

const setManagerUsersList = {
	[SECTORS_SET_MANAGER_USERS_LIST]: (state, action) => {
		return {
			...state,
			managerUsersList: action.payload,
		};
	},
};

const sectorUpdateList = {
	[SECTORS_UPDATE_LIST]: (state, action) => {
		return {
			...state,
			sectorsList: [...action.payload]
		}
	}
}

const sectorsReducer = createReducer(initialState, {
	...setSectorsList,
	...setManagerUsersList,
	...sectorUpdateList,
});

export default sectorsReducer;



// WEBPACK FOOTER //
// src/redux/reducers/sectorsReducer.js